import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Optimizes Auxo CDN image URLs with Cloudflare on-the-fly resizing and format conversion.
 */
export function getOptimizedImageUrl(url, { width = 800, quality = 85, fit = 'cover' } = {}) {
  if (!url || typeof url !== 'string') return ''
  if (!url.startsWith('https://assets.auxodev.dk/')) return url
  if (url.includes('/cdn-cgi/image/')) return url

  const origin = 'https://assets.auxodev.dk'
  const path = url.replace(origin, '')
  return `${origin}/cdn-cgi/image/width=${width},quality=${quality},fit=${fit},format=auto${path}`
}

/**
 * Strips HTML tags or returns sanitized text
 */
export function stripHtml(html) {
  if (!html) return ''
  return html.replace(/<[^>]*>?/gm, '')
}
